import script from "./AllJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./AllJobs.vue?vue&type=script&setup=true&lang=js"

import "./AllJobs.vue?vue&type=style&index=0&id=476be73e&lang=css"

const __exports__ = script;

export default __exports__